import { FC, Fragment } from 'react'
import { css } from '@emotion/react'
import { MyTheme, theme } from '@ui/styles/theme'

type TitleType = {
  title: string
}

const Title: FC<TitleType> = ({ title }) => {
  const styles = createStyles(theme)

  return (
    <Fragment>
      <h2 css={styles.title}>{title}</h2>
    </Fragment>
  )
}

const createStyles = (theme: MyTheme) => {
  return {
    title: css`
      margin-bottom: 12px;
      color: ${theme.colors.primary};
      font-size: 30px;
      font-weight: bold;
      font-family: 'montserrat', sans-serif;
      letter-spacing: 1px;
      line-height: 44px;
    `
  }
}

export default Title
